// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"739ff8ee","845":"f2e7368c"}[chunkId] + ".chunk.js";
};